import * as _ from "lodash";
import * as angular from "angular";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { HouseDataProvider } from "../../data-provider/house.dp";
import { HouseOccupantService } from "../../services/house-occupant.service";
import { Feature } from "../../models/feature.model";
import { PermissionCheck } from "../../shared/permission";
import { ResultDataProvider } from "../../data-provider/result.dp";
import { SurveyService } from "../../services/survey.service";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { CanvassService } from "../../services/canvass.service";
import { IssueService } from "../../services/issue.service";
import { Effort } from "../../models/effort.model";
import { CanvassStatusDataProvider } from "../../data-provider/canvass-status.dp";
import { House } from "../../models/house.model";
import { User } from "../../models/user.model";
import { CanvassStatus } from "../../models/canvass-status.model";
import { Appointment } from "../../models/appointment.model";
import { AppointmentDataProvider } from "../../data-provider/appointment.dp";
import { CustomFieldAttachmentModel } from "../../models/custom-field-attachment.model";

let CanvassFormComponent = {
    selector: "vcCanvassForm",
    templateUrl: "/angular/components/canvass/canvass-form.component.html",
    bindings: {
        selectedHouseOccupant: "=?",
        selectedHouse: "=?",
        selectedCanvass: "=?",
    },
    controller: class CanvassFormController {
        // * bindings for typescript compiler *
        public selectedHouseOccupant?: any;
        public selectedHouse?: any;
        public selectedCanvass?: any;
        // ************************************

        private errors: any = {};
        private saving = false;
        private house: House;
        private houseNote: string | null;
        private types: CanvassStatus[];
        private receptionFeature: Feature;
        private canvass: any;
        private efforts: Effort[];

        private $scope: any;
        private toast: ToastUtils;
        private __env: any;
        private modelsUtils: any;
        private dialog: DialogUtils;

        private service: CanvassService;
        private userDataProvider: UserDataProvider;
        private issueService: IssueService;
        private houseOccupantResource: HouseOccupantService;
        private surveyService: SurveyService;
        private effortDataProvider: EffortDataProvider;
        private fieldDataProvider: FieldDataProvider;
        private permissionProvider: PermissionCheck;
        private houseDataProvider: HouseDataProvider;
        private resultDataProvider: ResultDataProvider;
        private appointmentDataProvider: AppointmentDataProvider;

        constructor(
            $scope: any,
            __env: any,
            ToastUtils: ToastUtils,
            CanvassService: CanvassService,
            UserDataProvider: UserDataProvider,
            IssueService: IssueService,
            HouseOccupantService: HouseOccupantService,
            SurveyService: SurveyService,
            EffortDataProvider: EffortDataProvider,
            FieldDataProvider: FieldDataProvider,
            DialogUtils: DialogUtils,
            PermissionCheck: PermissionCheck,
            CanvassStatusDataProvider: CanvassStatusDataProvider,
            HouseDataProvider: HouseDataProvider,
            ResultDataProvider: ResultDataProvider,
            AppointmentDataProvider: AppointmentDataProvider,
            ModelsUtils: any
        ) {
            this.$scope = $scope;
            this.toast = ToastUtils;
            this.__env = __env;
            this.modelsUtils = ModelsUtils;
            this.dialog = DialogUtils;

            this.service = CanvassService;
            this.userDataProvider = UserDataProvider;
            this.issueService = IssueService;
            this.houseOccupantResource = HouseOccupantService;
            this.surveyService = SurveyService;
            this.effortDataProvider = EffortDataProvider;
            this.fieldDataProvider = FieldDataProvider;
            this.permissionProvider = PermissionCheck;
            this.houseDataProvider = HouseDataProvider;
            this.resultDataProvider = ResultDataProvider;
            this.appointmentDataProvider = AppointmentDataProvider;

            if (this.permissionProvider.hasPermission("RECEPTION")) {
                this.permissionProvider
                    .getFeature("RECEPTION")
                    .then((feature) => {
                        this.receptionFeature = feature;
                    });
            }

            CanvassStatusDataProvider.walkCanvassStatuses().then((statuses) => {
                this.types = statuses;
            });
        }

        $onInit() {
            this.house = this.selectedHouse
                ? _.cloneDeep(this.selectedHouse)
                : null;
            this.houseNote =
                !this.selectedCanvass && this.house && this.house.notes
                    ? this.house.notes
                    : null;

            if (this.selectedCanvass) {
                this.service
                    .info({ id: this.selectedCanvass.csid })
                    .then((response: object) => {
                        const json = response["data"];
                        if (json.success) {
                            let tmpCopy = _.cloneDeep(this.selectedCanvass);
                            this.canvass = _.merge(tmpCopy, json.data);
                            this.canvass.cscanvasser = this.modelsUtils.user(
                                this.canvass.user
                            );
                            if (
                                !this.canvass.houseoccupant ||
                                !this.canvass.houseoccupant.hoid
                            ) {
                                this.canvass.houseoccupant = null;
                            } else {
                                this.canvass.houseoccupant.customfields =
                                    this.fieldDataProvider.formatFields(
                                        this.canvass.houseoccupant.customfields
                                    );
                            }
                            if (this.canvass.survey) {
                                this.canvass.survey.saved = true;
                            }
                            if (this.canvass.effortid) {
                                this.effortDataProvider
                                    .getEffortById(this.canvass.effortid, false)
                                    .then((effort) => {
                                        this.canvass.effort = effort;
                                    });
                            }
                        }
                    });
            } else {
                this.canvass = {
                    cscanvasser: this.userDataProvider.getActiveUser(),
                    cssid: "1",
                    survey: null,
                    query: null,
                };
                if (this.selectedHouseOccupant) {
                    this.getHouseOccupantInfo(this.selectedHouseOccupant.hoid);
                } else if (
                    !this.canvass.houseoccupant &&
                    this.house &&
                    this.house.hid
                ) {
                    this.canvass.hid = this.house.hid;
                }

                this.effortDataProvider.getActiveEfforts().then((efforts) => {
                    this.efforts = efforts;
                    this.canvass.effort = efforts[0];
                    this.effortDataProvider
                        .getSelectedEffort(true)
                        .then((effort) => {
                            if (effort && effort.status !== "Archived") {
                                this.canvass.effort = effort;
                            }
                        });
                });

                if (
                    this.house &&
                    !this.permissionProvider.hasPermission("ANON_CANVASSING")
                ) {
                    this.houseOccupantResource
                        .house(this.house.hid)
                        .then((response: object) => {
                            const json = response["data"];
                            if (json.success) {
                                this.canvass.houseoccupant =
                                    this.modelsUtils.houseOccupant(
                                        json.data[0]
                                    );

                                this.canvass.houseoccupant.customfields =
                                    this.fieldDataProvider.formatFields(
                                        this.canvass.houseoccupant.customfields
                                    );
                            }
                        });
                }
            }
        }

        receptionText(rating: number): string {
            if (!this.receptionFeature.attributes.extra) {
                return "";
            }
            switch (rating) {
                case 1:
                    return this.receptionFeature.attributes.extra.veryUnlikely;
                case 2:
                    return this.receptionFeature.attributes.extra.unlikely;
                case 3:
                    return this.receptionFeature.attributes.extra.neutral;
                case 4:
                    return this.receptionFeature.attributes.extra.likely;
                default:
                    return this.receptionFeature.attributes.extra.veryLikely;
            }
        }

        getPriorityFields(fields: any[]): any[] {
            let priorityFields = [];
            angular.forEach(fields, (field) => {
                if (
                    field.priority == "1" &&
                    ((field.cftid != 4 && field.cftid != 5) ||
                        field.options.length)
                ) {
                    priorityFields.push(field);
                }
            });
            return priorityFields;
        }

        validCanvass(): boolean {
            this.errors = { customfields: {}, regularFields: {} };
            let valid = true;
            if (
                this.canvass.cssid == 1 &&
                !this.canvass.csreception &&
                this.permissionProvider.hasPermission("RECEPTION")
            ) {
                this.errors.reception = "A star rating is required";
                valid = false;
            }

            if (
                this.canvass.cssid == 1 &&
                this.canvass.houseoccupant &&
                this.canvass.houseoccupant.customfields
            ) {
                angular.forEach(
                    this.canvass.houseoccupant.customfields,
                    (field) => {
                        //only priority fields will appear during canvass
                        if (
                            field.priority != "1" ||
                            !this.isRequiredCustomField()(field)
                        )
                            return;

                        if (field.cftid == 7) {
                            const nonDeletedFiles = field.files.filter(
                                (file: CustomFieldAttachmentModel) => {
                                    return file.status != "Deleted";
                                }
                            );
                            valid = nonDeletedFiles.length > 0;
                            if (nonDeletedFiles.length <= 0) {
                                this.errors.customfields[field.cfid] =
                                    "This field is required";
                            }
                        } else {
                            if (!field.hokey) {
                                if (!field.value || field.value == 0) {
                                    this.errors.customfields[field.cfid] =
                                        "This field is required";
                                    valid = false;
                                }
                            } else {
                                if (
                                    (!this.canvass.houseoccupant[field.hokey] ||
                                        this.canvass.houseoccupant[
                                            field.hokey
                                        ] == 0) &&
                                    this.isRequired(field)
                                ) {
                                    if (
                                        field.name != "Deceased" &&
                                        field.name != "Volunteer" &&
                                        field.name != "Donor"
                                    ) {
                                        this.errors.regularFields[field.hokey] =
                                            "This field is required";
                                        valid = false;
                                    }
                                }
                            }
                        }
                    }
                );
            }
            return valid;
        }

        setFieldValue(field: any): void {
            if (field.cfid) {
                field.value = field.hocfvalue;
            }
            this.updateFields(field, this.canvass);
        }

        //custom field find the selected option
        selectedOption(options: any[]): object | null {
            let selectedOptions = options.filter(
                (option) => option.selected == 1
            );
            if (selectedOptions.length > 0) return selectedOptions[0];
            return null;
        }

        saveCanvass(): void {
            if (this.validCanvass()) {
                this.errors = [];
                this.canvass.timezone =
                    Intl.DateTimeFormat().resolvedOptions().timeZone;

                this.effortDataProvider.setSelectedEffort(this.canvass.effort);

                //TODO: MAKE LINK BETWEEN canvass.houseoccupant.customfields and priority fields used for attachments directive

                this.saving = true;
                if (
                    this.houseNote &&
                    this.house &&
                    this.house.notes != this.houseNote
                ) {
                    this.house.notes = this.houseNote;
                    this.canvass.house = this.modelsUtils.house(this.house);
                    this.canvass.house.update();
                    this.houseDataProvider.updateHouseIfExist(
                        this.canvass.house
                    );
                }

                if (this.canvass.houseoccupant) {
                    delete this.canvass.houseoccupant.hocreationdatetime;
                }

                if (
                    !angular.isUndefined(this.canvass.csid) &&
                    this.canvass.csid
                ) {
                    this.canvass.cslastmodifieddatetime = null;

                    if (this.canvass.query && this.canvass.query.csqdetails) {
                        this.canvass.query.csqid = this.canvass.csqid;
                        this.canvass.query.csqaassigned = angular.isDefined(
                            this.canvass.query.assigned.uid
                        )
                            ? this.canvass.query.assigned.uid
                            : null;
                        this.canvass.query.csqoid = this.canvass.query.origin
                            .csqoid
                            ? this.canvass.query.origin.csqoid
                            : null;
                    }

                    this.service.update(this.canvass).then(
                        (response: object) => {
                            const json = response["data"];
                            this.saving = false;
                            if (json.success) {
                                this.toast.success("Interaction updated.");
                                json.data.survey = this.canvass.survey;
                                json.data.query = this.canvass.query;
                                json.data.effort = this.canvass.effort;
                                this.dialog.hide(json.data);
                            }
                        },
                        () => {
                            this.saving = false;
                            this.toast.error(
                                "An error occurred. Please try again, or contact  " +
                                    this.__env.support_email
                            );
                        }
                    );
                } else {
                    if (this.canvass.cssid != 1) {
                        this.canvass.csreception = null;
                    }

                    if (this.canvass.query) {
                        this.canvass.query.csqaassigned = this.canvass.query
                            .assigned.uid
                            ? this.canvass.query.assigned.uid
                            : null;
                        this.canvass.query.csqoid = this.canvass.query.origin
                            .csqoid
                            ? this.canvass.query.origin.csqoid
                            : null;
                    }

                    this.service.create(this.canvass).then(
                        (response: object) => {
                            const json = response["data"];
                            this.saving = false;
                            if (json.success) {
                                if (this.resultDataProvider.isDummyData()) {
                                    this.resultDataProvider.dismissDummyData();
                                }
                                json.data.effort = this.canvass.effort;
                                this.canvass = json.data;
                                this.toast.success("Interaction created.");
                                this.dialog.hide(json.data);
                            }
                        },
                        (error) => {
                            this.saving = false;
                            this.toast.error(
                                "An error occurred. Please try again, or contact " +
                                    this.__env.support_email
                            );
                        }
                    );
                }
            }
        }

        deleteSurvey(): void {
            if (!this.canvass.csid) {
                this.canvass.survey = null;
            } else {
                this.surveyService
                    .deleteAnswers(this.canvass.csid)
                    .then((response: object) => {
                        const json = response["data"];
                        if (json.success) {
                            this.canvass.survey = null;
                        }
                    });
            }
        }

        deleteIssue(): void {
            if (!this.canvass.csid) {
                this.canvass.query = null;
            } else {
                this.issueService
                    .delete({ id: this.canvass.query.csqid })
                    .then((response: object) => {
                        const json = response["data"];
                        if (json.success) {
                            this.canvass.query = null;
                        }
                    });
            }
        }

        deleteAppointment(): void {
            if (!this.canvass.csid) {
                this.canvass.appointment = null;
            } else {
                this.appointmentDataProvider
                    .delete(this.canvass.appointment)
                    .then(
                        (appointment: any) => {
                            this.canvass.appointment = null;
                        },
                        (error: object) => {
                            this.toast.error(error);
                            console.log(error);
                        }
                    );
            }
        }

        openCanvassStatusDialog(canvass: any, ev: object): void {
            this.dialog
                .show({
                    component: "vc-canvass-status",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        selectedStatusId: canvass.cssid,
                    },
                    size: "small",
                    ariaLabel: "Change interaction status",
                })
                .then((id: string | number) => {
                    this.canvass.cssid = id;
                });
        }

        openCanvassHouseOccupantDialog(canvass: object, ev: object): void {
            this.dialog
                .show({
                    component: "vc-canvass-house-occupant",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        selectedHid: this.canvass.hid,
                        selectedHouseoccupant: this.canvass.houseoccupant,
                    },
                    ariaLabel: "Change Person",
                })
                .then((houseoccupant: any) => {
                    this.canvass.houseoccupant = houseoccupant;
                    this.canvass.houseoccupant.customfields =
                        this.fieldDataProvider.formatFields(
                            this.canvass.houseoccupant.customfields
                        );
                });
        }

        openCanvassEffortDialog(canvass: object, ev: object): void {
            this.dialog
                .show({
                    component: "vc-canvass-effort",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        selectedEffort: this.canvass.effort,
                    },
                    size: "small",
                    ariaLabel: "Change Effort",
                })
                .then((effort: any) => {
                    this.canvass.effort = effort;
                });
        }

        openCanvasserDialog(canvass: object, ev: object): void {
            this.dialog
                .show({
                    component: "vc-canvasser",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        selectedUser: this.canvass.cscanvasser,
                    },
                    ariaLabel: "Change Member",
                })
                .then((user: User) => {
                    this.canvass.cscanvasser = user;
                });
        }

        openHouseNoteDialog(houseNote: string | null, ev: object): void {
            this.dialog
                .show({
                    component: "vc-house-note-form",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: false,
                    scope: this.$scope,
                    ariaLabel: "Notes",
                    locals: {
                        houseNote: houseNote,
                    },
                })
                .then((data: unknown) => {
                    // The promise can be resolved by an unrelated
                    // $mdDialog.hide(), so only keep text (AV-18111).
                    if (typeof data === "string") this.houseNote = data;
                });
        }

        openFieldDialog(
            selectedField: any,
            canvass: object,
            ev: object,
            value: any
        ): boolean {
            if (
                selectedField.cftid == 6 ||
                selectedField.hokey == "hodeceased" ||
                selectedField.hokey == "hovolunteer" ||
                selectedField.hokey == "hodonor"
            ) {
                return false;
            }

            if (!selectedField.cfid && value) {
                selectedField.value = value;
            }

            if (angular.isDefined(selectedField.cftid) && selectedField.cftid) {
                this.dialog
                    .show({
                        component: "vc-canvass-custom-field",
                        targetEvent: ev,
                        scope: this.$scope,
                        skipHide: true,
                        multiple: true,
                        locals: {
                            selectedField: selectedField,
                        },
                        ariaLabel: "Change Custom Field",
                    })
                    .then((updatedField) => {
                        if (angular.isDefined(updatedField.options)) {
                            angular.forEach(updatedField.options, (option) => {
                                if (option.selected == 1) {
                                    updatedField.value = true;
                                    return;
                                }
                            });
                        }
                        this.updateFields(updatedField, canvass);
                    });
            } else {
                this.dialog
                    .show({
                        component: "vc-canvass-regular-field",
                        targetEvent: ev,
                        scope: this.$scope,
                        skipHide: true,
                        multiple: true,
                        locals: {
                            selectedField: selectedField,
                            canvass: canvass,
                        },
                        size: "auto",
                        ariaLabel: "Change Regular Field",
                    })
                    .then((updatedField) => {
                        if (updatedField.value == "") updatedField.value = null;
                        this.updateFields(updatedField, canvass);
                        this.canvass.houseoccupant[selectedField.hokey] =
                            updatedField.value;
                        if (
                            !angular.isUndefined(updatedField.esid) &&
                            updatedField.esid > 0
                        ) {
                            this.canvass.houseoccupant.esid = updatedField.esid;
                        }
                    });
            }
        }

        updateFields(updatedField: any, canvass: any): void {
            angular.forEach(canvass.houseoccupant.customfields, (field) => {
                if (field.id == updatedField.id) {
                    updatedField.hocfvalue = updatedField.value;
                    _.merge(field, updatedField);
                }
            });

            if (
                this.errors.customfields &&
                this.errors.customfields[updatedField.cfid]
            ) {
                delete this.errors.customfields[updatedField.cfid];
            }
            if (
                this.errors.regularFields &&
                this.errors.regularFields[updatedField.hokey]
            ) {
                delete this.errors.regularFields[updatedField.hokey];
            }
        }

        openCreateIssueDialog(canvass: any, ev: any): void {
            this.dialog
                .show({
                    component: "vc-create-issue",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: false,
                    ariaLabel: "Change Custom Field",
                    class: "create-issue-dialog",
                    scope: this.$scope,
                    locals: {
                        selectedIssue: canvass.query,
                        selectedHoid: null,
                        selectedCanvasser: canvass.cscanvasser,
                        dialogType: "canvass",
                    },
                })
                .then((query) => {
                    canvass.query = query;
                });
        }

        openCreateAppointmentDialog(canvass: any, ev: any): void {
            var canvassCopy = _.cloneDeep(canvass);
            canvassCopy.house = this.house ?? null;
            this.dialog
                .show({
                    component: "vc-appointment-form",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: false,
                    ariaLabel: "Create Appointment",
                    class: "create-appointment-dialog",
                    scope: this.$scope,
                    size: "large",
                    locals: {
                        canvass: canvassCopy,
                    },
                })
                .then((appointment: Appointment) => {
                    if (appointment) {
                        canvass.appointment = appointment.getData();
                    } else {
                        canvass.appointment = null;
                    }
                });
        }

        openCanvassSurveyDialog(canvass: any, ev: any): void {
            this.dialog
                .show({
                    component: "vc-canvass-survey",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        selectedSurvey: canvass.survey,
                    },
                    size: "large",
                    ariaLabel: "Change Custom Field",
                    class: "Change Custom Field",
                })
                .then((survey: any) => {
                    canvass.survey = survey;
                });
        }

        populatedOption(): (option: any) => boolean {
            return (option) => {
                return option.selected == 1;
            };
        }

        isRequiredCustomField(): (field: any) => boolean {
            return (field) => {
                if (field.required == 1) {
                    if (
                        (field.cftid == 4 || field.cftid == 5) &&
                        field.options.length === 0
                    ) {
                        return false;
                    }
                    return true;
                }
                return false;
            };
        }

        dismissDialog(ev: any): void {
            if (!this.canvass.csid && this.canvass.appointment) {
                this.dialog
                    .delete({
                        targetEvent: ev,
                        multiple: true,
                        locals: {
                            bodyText:
                                "Your appointment will not be created if you cancel the interaction",
                            title: "Are you sure?",
                        },
                    })
                    .then(() => {
                        this.dialog.cancel();
                    });
            } else {
                this.dialog.cancel();
            }
        }

        getHouseOccupantInfo(hoid: string): void {
            this.houseOccupantResource.info(hoid).then((response: object) => {
                const json = response["data"];
                if (json.success) {
                    let customfields = json.data.customfields ?? null;
                    this.canvass.houseoccupant = this.modelsUtils.houseOccupant(
                        json.data
                    );
                    this.house = json.data.house;
                    if (this.house) {
                        this.houseNote = this.canvass.houseoccupant.house.notes;
                    }
                    this.canvass.houseoccupant.customfields =
                        this.fieldDataProvider.formatFields(customfields);
                }
            });
        }

        showAppointment(): boolean {
            if (this.canvass) {
                if (this.canvass.cssid == 1) {
                    return true;
                }
                const status: any = this.types.filter((canvassStatus: any) => {
                    return canvassStatus.id == this.canvass.cssid;
                })[0];
                return !!status.workflow && status.workflow["appointment"];
            }
            return false;
        }

        isRequired(field: any): boolean {
            if (field.hokey && this.isProspectorField(field.hokey)) {
                return false;
            }
            return field.required === "1";
        }

        isReadOnly(field: any): boolean {
            if (field.hokey && this.isProspectorField(field.hokey)) {
                return true;
            }
            return field.readonly === "1";
        }

        isProspectorField(key: string): boolean {
            let prospectorDisabledFields = [
                "hofname",
                "holname",
                "hogender",
                "homobilephone",
                "hohomephone",
                "hoparty",
                "hodob",
                "hoyob",
                "donor_environmental",
                "credit_rating",
                "income",
            ];
            return (
                this.canvass.houseoccupant.unique_id &&
                prospectorDisabledFields.includes(key)
            );
        }
    },
};

angular
    .module("canvass")
    .component(CanvassFormComponent.selector, CanvassFormComponent);
